import {EdgePlan} from 'app/models/EdgePlan/EdgePlan';

function mapCloudTier(c: Contracts.Billing.Cloud.Tier): App.Billing.Cloud.Tier {
  return {
    id: c.id,
    name: c.name,
    rate: c.rate,
    description: c.description,
    seats: c.max_devices,
    isAvailable: c.is_available,
    isDefault: c.is_default,
    isDeleted: c.is_deleted,
  };
}

const defaultTier: App.Billing.Cloud.Tier = {
  id: '',
  name: 'Free',
  description: '',
  isAvailable: true,
  isDefault: true,
  isDeleted: false,
  seats: -1,
  rate: 0,
};

function mapEdgePlan(c: Contracts.Billing.Cloud.Plan): EdgePlan {
  const {id, name, trial} = c;

  const tiers = c.tiers.map(mapCloudTier);
  const tier = tiers.find((t) => t.id === c.current_tier) ?? {...defaultTier};

  return new EdgePlan({
    name,
    id,
    tier,
    tiers,
    prices: {
      seat: c.seat_month_price,
      transcriber: c.transcribing_cost_hour,
      unify: c.vpearl_cost_hour,
    },
    interval: {
      dimension: c.interval,
      count: c.interval_count,
    },
    period: {
      begin: c.current_period_start,
      end: c.current_period_end,
    },
    trial: trial ? {active: trial.is_active, from: trial.from, to: trial.to} : undefined,
  });
}

export const BillingMapper = {mapEdgePlan};
